'use strict';

var parameters = new URLSearchParams(window.location.search);
var mockData = parameters.get('test_data'); // VD: &test_data=[{"id":"1104140420369","lastCategoryName":"パンツ_0"}] (when data not mapping with SFCC)
var customerID = parameters.get('test_customer_id'); // VD: &test_customer_id=111122222 (hard coded customer id for testing)
var LoginUserId = '';

// random unique id for guest user
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

// check and save guest user id in localStorage
var guestUserId = localStorage.getItem("guestUserId");
if (!guestUserId) {
    guestUserId = generateUUID();
    localStorage.setItem("guestUserId", guestUserId);
}

// login call braze.changeUser
function login() {
    // priority to get id when user logs in SFCC (LoginUserId)
    // if guest user then use from localStorage (guestUserId)
    var finalUserId = LoginUserId ? LoginUserId : guestUserId;

    // final priority for testing
    if (customerID) {
        finalUserId = customerID;
    }

    var payload = {
        sub: finalUserId,
        exp: 9999999999,
    };

    braze.changeUser(finalUserId, JSON.stringify(payload));
}

// handle resize event for swiper
function effectBraze(dataId, swiper) {  
    var ww = $(window).width();

    if (ww>764) {
        var prevarrow = $('.prev-button-' + dataId)[0];
        var nextarrow = $('.next-button-' + dataId)[0];

        // default state button next prev when page load 
        prevarrow.style.display = 'none';
        nextarrow.style.display = swiper.slides.length <= swiper.params.slidesPerView ? 'none' : 'block';

        swiper.on('slideChange', function() {
            var realIndex = swiper.realIndex;
            var activeIndex = swiper.slides.length - swiper.params.slidesPerView;
            realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
            realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
        });
    }
    if (ww<=764) {
        swiper.params.spaceBetween = 0;
        $('.prev-button-' + dataId).hide();
        $('.next-button-' + dataId).hide();
    }

    // hide slider if item slide is zero
    if (swiper.slides.length == 0) {
       $('.braze-rec').hide();
    }
}

// run for all page
function syncSwiperBraze() {
    var elmBraze = $('.swiper__recommendproduct_braze');
    var dataId = elmBraze.data('id');
    var pageType = elmBraze.data('pagetype');

    var defaultConfig = {
        enabled: false, // swiper unable on mobile, replace by css scroll
        slidesPerView: 2.5,
        a11y: false,
        loopedSlides: 2,
        preloadImages: false,
        loop: false,
        centeredSlides: false,
        navigation: {
            nextEl: '.next-button-' + dataId,
            prevEl: '.prev-button-' + dataId
        },
    }   

    if (pageType == 'top_page') {
        // config for top page
        defaultConfig = {
            ...defaultConfig,
            spaceBetween: 0.1,
            breakpoints: {
                768: {
                    enabled: true,
                    slidesPerView: 5,
                }
            }
        }
    } else {
        // config for all page exclude top page
        defaultConfig = {
            ...defaultConfig,
            spaceBetween: 5,
            breakpoints: {
              768: {
                enabled: true,
                slidesPerView: 4
              }
            }
        }
    }

    var swiper = new Swiper('.' + dataId, defaultConfig);

    // execute some effect when page load
    effectBraze(dataId, swiper);
}

// fetch content cards from braze
async function fetchContentCards() {
    function getRecommendation() {
      window.dataLayer = window.dataLayer || []
      for (var i = 0; i < window.dataLayer.length; i++) {
        var item = window.dataLayer[i];
        if (
          item.event === "braze_recommendation" &&
          Array.isArray(item.recommendation) &&
          item.recommendation.length > 0) {
          return item.recommendation;
        }
      }
    }
  
    try {
        var pidList = [];
        var recWrapper = $('#rec-wrapper');
        var urlBraze = recWrapper.data('url');
        if (!urlBraze) {
            return;
        }
    
        // [Breathe] Just get recommendations from data layer
        var cards = getRecommendation();
    
        // should is true or false for testing UI
        if (!cards || cards.length === 0) {
            console.error("No content cards found.");
            return;
        }

        cards.forEach(function(subItem) {
            pidList.push({id: subItem.id, lastCategoryName: subItem.lastCategoryName});
        });
  
      // request render template
      $.ajax({
        url: urlBraze,
        type: 'POST',
        data: {
          pidList: JSON.stringify(pidList),
          mockData: mockData || "",
        },
        success: function (response) {
          if (response.success) {
            // Minimal safety: destroy existing instance (if any) BEFORE replacing DOM
            try {
                var existingId = $('.swiper__recommendproduct_braze').data('id');
                var existingEl = document.querySelector('.' + existingId);
                if (existingEl && existingEl.swiper) {
                existingEl.swiper.destroy(true, true);
                }
            } catch (e) {
                console.warn('Could not destroy existing Swiper instance:', e);
            }
            recWrapper.html(response.renderTemplate);
            // Re-initialize on the new DOM
            syncSwiperBraze();
          } else {
            console.error("Error rendering recommendation.", response.error);
          }
        },
        error: function (xhr, status, error) {
          console.error("AJAX error:", error);
        }
      });
    } catch (error) {
      console.error("Error fetching content cards:", error);
    }
}

$(window).on('load', function(){
    var originalPush = window.dataLayer.push;
    window.dataLayer.push = async function () {
        try {
            for (var i = 0; i < arguments.length; i++) {
                var item = arguments[i];
                if (!item["event"]) {
                    continue;
                }
            }

            // originalPush.apply for step getRecommendation get dataLayer
            originalPush.apply(window.dataLayer, arguments)
            // fetch content cards when dataLayer is braze_recommendation
            if (item.event === "braze_recommendation" &&
                Array.isArray(item.recommendation) &&
                item.recommendation.length > 0) {
                await fetchContentCards();
            }
        } catch (e) {
            console.error("Braze Contents Card Datalayer Error: " + e);
        }
    };

    // wait element load because element slow display by ajax
    var intervalBraze = setInterval(function () {
        var elmBraze = $('.swiper__recommendproduct_braze');
        if (elmBraze.length > 0) {
            // stop interval when element is loaded
            clearInterval(intervalBraze);
            // init swiper when element is loaded
            syncSwiperBraze();
        }
    });

    // stop interval when element is not loaded after 7s if not find element braze
    setTimeout(function() {
        clearInterval(intervalBraze);
    }, 7000);

    // get member id when user login SFCC
    LoginUserId = $('#maincontent').data('user-id');
    var initIntervalBraze = setInterval(function () {
        if (window.braze && braze.isInitialized()) {
            // login before showContentCards
            login();

            // braze banner display
            braze.subscribeToBannersUpdates((banners) => {
                const globalBanner = braze.getBanner(Resources.BRAZE_BANNER_ONE);
                if (globalBanner) { 
                    const bannerElement = document.getElementById('main-top-1');
                    if (globalBanner && bannerElement) {
                        bannerElement.style.display = "block";
                        braze.insertBanner(globalBanner, bannerElement);
                    }
                } 

                const globalBanner2 = braze.getBanner(Resources.BRAZE_BANNER_TWO);
                if (globalBanner2) { 
                    const bannerElement2 = document.getElementById('main-top-2');
                    if (globalBanner2 && bannerElement2) {
                        bannerElement2.style.display = "block";
                        braze.insertBanner(globalBanner2, bannerElement2);
                    } 
                } 

                const globalBanner3 = braze.getBanner(Resources.BRAZE_BANNER_THREE);
                if (globalBanner3) { 
                    const bannerElement3 = document.getElementById('main-top-3');
                    if (globalBanner3 && bannerElement3) {
                        bannerElement3.style.display = "block";
                        braze.insertBanner(globalBanner3, bannerElement3);
                    }
                }

                const globalBanner4 = braze.getBanner(Resources.BRAZE_BANNER_FOUR);
                if (globalBanner4) { 
                    const bannerElement4 = document.getElementById('main-top-4');
                    if (globalBanner4 && bannerElement4) {
                        bannerElement4.style.display = "block";
                        braze.insertBanner(globalBanner4, bannerElement4);
                    }
                }

                const globalBanner5 = braze.getBanner(Resources.BRAZE_BANNER_FIVE);
                if (globalBanner5) { 
                    const bannerElement5 = document.getElementById('main-top-5');
                    if (globalBanner5 && bannerElement5) {
                        bannerElement5.style.display = "block";
                        braze.insertBanner(globalBanner5, bannerElement5);
                    } 
                }
            });

            // open session to braze
            braze.openSession();

            braze.requestBannersRefresh([
                Resources.BRAZE_BANNER_ONE,
                Resources.BRAZE_BANNER_TWO,
                Resources.BRAZE_BANNER_THREE,
                Resources.BRAZE_BANNER_FOUR,
                Resources.BRAZE_BANNER_FIVE
            ]);
            processBrazeBanner(initIntervalBraze);
        }
    }, 500);

    // stop interval when element is not loaded after 7s if not find element braze
    setTimeout(function() {
        clearInterval(initIntervalBraze);
    }, 7000);
});

function processBrazeBanner(callback) {
    clearInterval(callback);
    // delay 1s to show braze banner
    setTimeout(function() {
        $('#main-top-1').length && $('#main-top-1').css('display') === 'none' ? $('#main-top-1').remove() : null;
        $('#main-top-2').length && $('#main-top-2').css('display') === 'none' ? $('#main-top-2').remove() : null;
        $('#main-top-3').length && $('#main-top-3').css('display') === 'none' ? $('#main-top-3').remove() : null;
        $('#main-top-4').length && $('#main-top-4').css('display') === 'none' ? $('#main-top-4').remove() : null;
        $('#main-top-5').length && $('#main-top-5').css('display') === 'none' ? $('#main-top-5').remove() : null;
        $('.braze-display-banner').addClass('header-banner-braze');
        $('.braze-display-banner').css('top', '-9999px');
        $('.braze-display-banner').css('left', '-9999px');
        $('.braze-display-banner').css('position', 'absolute');
        $('.braze-display-banner').removeClass('d-none');
        setTimeout(function() {
            $('.header-banner-braze').slick({
                autoplay: true,
                slidesToShow: 1,
                vertical: true,
                arrows: false,
                autoplaySpeed: 2500
            });
            $('.braze-display-banner').css('position', '');
            $('.braze-display-banner').css('top', '');
            $('.braze-display-banner').css('left', '');
            $(window).trigger('scroll');
        }, 500);
    }, 1500);
}